import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Para} from "@irati/ui/src/Labels"
import {SIDEBAR_INDENT} from "../SideBar/styled"
import {Content} from "../StepContent/styled"

export const InviteContent = styled(Content)`
  background-color: ${({theme}) => theme.colors.greys.white};
`
export interface InviteAdminProps {
  active?: boolean
}
export const InviteAdminWrapper = styled(Flex)<InviteAdminProps>`
  padding: 12px 0;
  padding-left: ${SIDEBAR_INDENT};
  cursor: pointer;
  ${({theme, active}) => active && `background-color: ${theme.colors.greys.light};`}
  &:hover {
    text-decoration: underline;
  }
`

export const SpacedPara = styled(Para)`
  padding-left: 15px;
`

export const Img = styled.img`
  width: 181px;
  margin-bottom: 30px;
`

interface MaxWContentProps {
  maxWidth: string,
  margin?: string
}
export const MaxWContent = styled.div<MaxWContentProps>`
  max-width: ${({maxWidth}) => maxWidth};
  ${({margin}) => `margin: ${margin};`}
`

export const MarginBottom = styled.div`
  margin-bottom: 25px;
`

export const MarginButton = styled(Button)`
  margin-left: 15px;
`
